import api from 'api';
import { IResourceAttribute } from 'hooks/useResourceAttribute/types';
import { convertRawQueriesToTraceSelectedTags } from 'hooks/useResourceAttribute/utils';
// eslint-disable-next-line no-restricted-imports
import { Dispatch } from 'redux';
import { GlobalTime } from 'types/actions/globalTime';

import { ActionTypes } from './types';

export interface ServiceMapStore {
	items: ServicesMapItem[];
	loading: boolean;
	error: boolean;
}

export interface ServicesMapItem {
	parent: string;
	child: string;
	callCount: number;
	callRate: number;
	errorRate: number;
	p99: number;
}

export interface ServiceMapItemAction {
	type: ActionTypes.getServiceMapItems;
	payload: ServicesMapItem[];
}

export interface ServiceMapLoading {
	type: ActionTypes.serviceMapLoading;
	payload: {
		loading: ServiceMapStore['loading'];
		error: ServiceMapStore['error'];
	};
}

export const getDetailedServiceMapItems =
	(globalTime: GlobalTime, queries: IResourceAttribute[]) =>
	async (dispatch: Dispatch): Promise<void> => {
		const start = `${globalTime.minTime}`;
		const end = `${globalTime.maxTime}`;

		const serviceMapPayload = {
			start,
			end,
			tags: convertRawQueriesToTraceSelectedTags(queries),
		};

		// 재조회에도 loading 을 올린다. 예전에는 false 만 디스패치해서,
		// 시간 범위를 바꿔도 갱신 중이라는 신호가 전혀 없었다.
		dispatch<ServiceMapLoading>({
			type: ActionTypes.serviceMapLoading,
			payload: { loading: true, error: false },
		});

		try {
			const dependencyGraphResponse = await api.post<ServicesMapItem[]>(
				`/dependency_graph`,
				serviceMapPayload,
			);

			dispatch<ServiceMapItemAction>({
				type: ActionTypes.getServiceMapItems,
				payload: dependencyGraphResponse.data,
			});

			dispatch<ServiceMapLoading>({
				type: ActionTypes.serviceMapLoading,
				payload: { loading: false, error: false },
			});
		} catch {
			// 실패해도 items 는 건드리지 않는다. 직전에 성공한 그래프를 지우면
			// 일시적인 조회 실패에 화면이 통째로 사라진다.
			// loading 을 반드시 내려야 스피너가 영원히 도는 상태를 막는다.
			dispatch<ServiceMapLoading>({
				type: ActionTypes.serviceMapLoading,
				payload: { loading: false, error: true },
			});
		}
	};
